"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "@/components/ui/Link";
import { getTimeAgo } from '@/lib/componentutills';
type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};
type Props = {
  date?: FieldConfig;
  title?: FieldConfig;
  excerpt?: FieldConfig;
  slug?: string;
};
export default function HorizontalDateNews(t0) {
  const $ = _c(27);
  const {
    date: t1,
    title: t2,
    excerpt: t3,
    slug
  } = t0;
  let t4;
  if ($[0] !== t1) {
    t4 = t1 === undefined ? {
      hidden: false,
      value: "April 12, 2023 12:37 IST ",
      customClass: ""
    } : t1;
    $[0] = t1;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const date = t4;
  let t5;
  if ($[2] !== t2) {
    t5 = t2 === undefined ? {
      hidden: false,
      value: "\u0B9A\u0BA8\u0BCD\u0BA4\u0BCB\u0BB7 \u0BA8\u0BAE\u0B9A\u0BC1\u0BB0\u0BC8 \u0BA4\u0BC7\u0BB5 \u0BB5\u0BB0\u0BC1\u0B95\u0BBF\u0BB1\u0BC0\u0BB0\u0BCD\u0B95\u0BB3\u0BBE",
      customClass: ""
    } : t2;
    $[2] = t2;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const title = t5;
  let t6;
  if ($[4] !== t3) {
    t6 = t3 === undefined ? {
      hidden: false,
      value: "\u0BAA\u0BC1\u0BA4\u0BC1\u0B95\u0BBF\u0BB0\u0BAE\u0BC8 \u0BAA\u0B9E\u0BCD\u0B9A\u0BBE\u0BAF\u0BBF\u0BB2\u0BCD \u0B89\u0BB3\u0BCD\u0BB3 \u0BAA\u0BC1\u0BA4\u0BC1\u0B9A\u0BC7\u0BB0\u0BBF \u0B87\u0BB0\u0BBE\u0BA3\u0BC1\u0BB5 \u0BA8\u0BBF\u0BB2\u0BC8\u0BAF\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD \u0BA4\u0BAE\u0BBF\u0BB4\u0BBE\u0B99\u0BCD\u0B95\u0BBF\u0B95\u0BB3\u0BCD \u0BB5\u0BC6\u0BB3\u0BCD\u0BB3\u0BBF\u0BAF\u0BBF\u0BB2\u0BCD \u0B9A\u0BB0\u0BCD\u0BB5\u0BAA\u0BBE\u0BB0\u0BCD \u0BAA\u0BC1\u0BB2\u0BA9\u0BCD\u0B95\u0BBE\u0BB5\u0BB2\u0BA9\u0BCD \u0B8F\u0BB1\u0BCD\u0B95\u0BA4\u0BCD\u0BA4\u0BC1\u0BB5\u0BBF\u0BAF\u0BC1\u0BAA\u0BAE\u0BCD \u0B9C\u0BBE\u0BA4\u0B95\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD \u0BA8\u0BBE\u0BB0\u0BAE\u0BCD \u0BB5\u0BBF\u0BB0\u0BBE\u0BAE \u0B95\u0BCA\u0BB2\u0BC8\u0BB5\u0BB4\u0B95\u0BCD\u0B95\u0B9F\u0BBE\u0B95 \u0B85\u0BB1\u0BBF\u0BA4\u0BBE\u0BB2\u0BCD \u0BAE\u0BC1\u0BB0\u0BBE\u0BA3\u0BC1\u0BB5\u0BAE\u0BCD \u0BAA\u0BC1\u0BA4\u0BC1\u0B9A\u0BC7\u0BB0\u0BCD\u0BAE\u0BC1\u0B95\u0BAE\u0BCD \u0BAE\u0BB2\u0BBF\u0B9A\u0BBF \u0BB5\u0BC7\u0B9F\u0BAA\u0B95\u0BBE\u0BAE\u0BC8 \u0BA4\u0BC7\u0BB5\u0BB0\u0BC1\u0B99\u0BCD\u0B95\u0BBF\u0BAF\u0BC1\u0BAA\u0BAE\u0BCD \u0B87\u0BA8\u0BCD\u0BA4 \u0B8A\u0BB4\u0BBF\u0B95\u0BB0\u0BC1\u0BB2\u0BCD\u0BB2\u0BC1\u0BAA\u0BCD\u0BAA\u0BC1\u0BA4\u0BCD\u0BA4\u0BC1. \u0B87\u0BA4\u0BA9 \u0BAE\u0BB2\u0BBF\u0B9A\u0BBF-\u0BAA\u0BC1\u0BA4\u0BC1\u0B9A\u0BC7\u0BB0\u0BCD \u0B9A\u0BBF\u0BB2\u0BC8\u0BAF\u0BBE\u0BB0\u0BCD \u0B85\u0BAE\u0BCD\u0BAE\u0BBE\u0BA9\u0BCD \u0BAE\u0BC6\u0BB0\u0BBF\u0BB5\u0BBE\u0BB0\u0BBF\u0B95\u0BB3\u0BCD \u0BAE\u0BB0\u0BBF\u0BB5\u0BBE\u0BB0\u0BBF\u0B95\u0BCD\u0B95\u0BB3\u0BBE\u0BAE\u0BCD.",
      customClass: ""
    } : t3;
    $[4] = t3;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const excerpt = t6;
  const t7 = date?.value;
  let t8;
  if ($[6] !== t7) {
    t8 = getTimeAgo(t7);
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const dateValue = t8;
  const titleValue = title?.value || "";
  const excerptValue = excerpt?.value || "";
  let t9;
  if ($[8] !== date?.customClass || $[9] !== date?.hidden || $[10] !== dateValue) {
    t9 = !date?.hidden && <div className={`bg-ECEEF3 text-14-tamil-600 text-2D497E w-fit px-3 py-1.5 ${date?.customClass || ""}`}>{dateValue}</div>;
    $[8] = date?.customClass;
    $[9] = date?.hidden;
    $[10] = dateValue;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== title?.customClass || $[13] !== title?.hidden || $[14] !== titleValue) {
    t10 = !title?.hidden && <h3 className={`text-1B1B1B text-18-tamil-700 leading-snug ${title?.customClass || ""}`}>{titleValue}</h3>;
    $[12] = title?.customClass;
    $[13] = title?.hidden;
    $[14] = titleValue;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== excerpt?.customClass || $[17] !== excerpt?.hidden || $[18] !== excerptValue) {
    t11 = !excerpt?.hidden && <p className={`text-1B1B1B text-16-tamil-400 leading-[1.6] line-clamp-3 ${excerpt?.customClass || ""}`}>{excerptValue}</p>;
    $[16] = excerpt?.customClass;
    $[17] = excerpt?.hidden;
    $[18] = excerptValue;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t10 || $[21] !== t11 || $[22] !== t9) {
    t12 = <div className="bg-F8F8F8 border border-DCDCDC p-6 flex flex-col gap-4">{t9}{t10}{t11}</div>;
    $[20] = t10;
    $[21] = t11;
    $[22] = t9;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  const content = t12;
  if (slug) {
    const t13 = `/${slug}`;
    let t14;
    if ($[24] !== content || $[25] !== t13) {
      t14 = <Link href={t13} className="block hover:bg-gray-100 transition-colors cursor-pointer">{content}</Link>;
      $[24] = content;
      $[25] = t13;
      $[26] = t14;
    } else {
      t14 = $[26];
    }
    return t14;
  }
  return content;
}